module.exports = __webpack_public_path__ + "img/aurory-project.8b487d12.png";